/**
 * These are generator functions which are primarily used when using the drag'n'drop
 * UI to add new sections, etc.
 */
import {
	CertificateLocale,
	UpsertModuleRequest,
	UpsertPartRequest,
	UpsertProgramRequest,
} from '@front-app/api-generated/learning-management-api';
import { EMPTY_COUNTRY, EMPTY_REGION } from '@front-app/components/inputs/CountryPickerData';
import {
	NewLearningStep,
} from '../../Model';

export function createProgram(): Required<Omit<UpsertProgramRequest, 'id'>> {
	return {
		name: '',
		identifier: '',
		credits: 0,
		speakers: [],
		description: '',
		certificateText: '',
		sendCertificate: false,
		sendCertificateDateStart: null,
		showAccreditedBadge: false,
		publishDateEnd: null,
		publishDateStart: null,
		certificateLocale: CertificateLocale.EnCa,
		location: {
			street1: '',
			street2: '',
			city: '',
			provStateRegion: EMPTY_REGION,
			country: EMPTY_COUNTRY,
			postalCode: '',
		},
	};
}

export function createModule(): UpsertModuleRequest {
	return {
		orderIndex: 0,
		name: '',
		credits: 0,
		speakers: [],
		description: '',
		publishDateStart: null,
		sendCertificate: false,
		sendCertificateDateStart: null,
	};
}

export function createPart(): UpsertPartRequest {
	return {
		orderIndex: 0,
		name: '',
		description: '',
		credits: 0,
		speakers: [],
	};
}

export function createStep(): NewLearningStep {
	return {
		orderIndex: 0,
		name: '',
		speakers: [],
		content: {
			type: 'none',
			id: '',
		},
	};
}
